import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import {del, set} from "object-path-immutable";
import {uid} from "react-uid";
import {Icon, IconButton, makeStyles, TextField} from "@material-ui/core";
import {ColorPicker} from "../../Components/ApplicationBuilder/ApplicationDesigner/Designers/ScreenDesigner/ToolBar/Panels/Styles/InputFields";
//const template = 'linear-gradient(92deg, rgba(2,0,36,1) 0%, rgba(44,99,134,1) 100%, rgba(50,114,148,1) 100%, rgba(64,146,180,1) 100%';
const template = '';
const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
            '& $removeBtn': {
                visibility: "visible"
            }
        }
    },
    removeBtn: {
        visibility: "hidden"
    },
}))
const GradientGenerator = ({color = template, onChange}) => {
    const [values, setValues] = useState([]);
    const [deg, setDeg] = useState("90deg");
    const classes = useStyles();
    useEffect(() => {
        if (color) {
            const stringValues = color.slice(16, color.length - 1);
            const reg = new RegExp(/,\s(?![^()]*(?:\([^()]*\))?\))/)
            const arrValues = stringValues.split(reg);
            const colors = arrValues.slice(1);
            setValues(colors)
            setDeg("90deg")
        }
    }, [color])

    function onChangeValues(v, i, type) {
        const currentValue = values[i];
        const regPair = new RegExp(/\s(?![^()]*(?:\([^()]*\))?\))/)
        const [color, position] = currentValue.split(regPair);
        const newValues = set(values, i, `${type === 'color' ? v : color || ''} ${type === 'position' ? v : position || ''}`)
        setValues(newValues)
        onChange({colors: newValues, deg}, 'gradient')
    }

    function onRemove(i) {
        const newValues = del(values, i)
        setValues(newValues)
        onChange({colors: newValues, deg}, 'gradient')
    }

    function onCreate() {
        const newValues = [...values, 'rgba(0,0,0,1)'];
        setValues(newValues)
        onChange({colors: newValues, deg}, 'gradient')
    }

    return (
        <div>
            <div style={{background: color, width: '100%', height: 5}}/>
            {values.map((item, i) => {
                const regPair = new RegExp(/\s(?![^()]*(?:\([^()]*\))?\))/)
                const [color, position] = item.split(regPair)
                return (
                    <div className={classes.container} key={uid(i)}>
                        <ColorPicker
                            values={{color}}
                            path={'color'}
                            setValue={(color) => {
                                onChangeValues(color, i, 'color')
                            }}
                            withGradient={false}
                            width={140}
                        />
                        <TextField
                            value={position}
                            style={{width: 95, marginLeft: 10}}
                            onChange={(e) => onChangeValues(e.target.value, i, 'position')}
                        />
                        <div>
                            <IconButton size={"small"} className={classes.removeBtn} onClick={() => onRemove(i)}>
                                <Icon fontSize={"small"}>
                                    clear
                                </Icon>
                            </IconButton>
                        </div>
                    </div>
                )
            })}
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <IconButton size={"small"} onClick={onCreate}>
                    <Icon fontSize={"small"}>
                        add
                    </Icon>
                </IconButton>
            </div>

        </div>
    )
}
export default GradientGenerator

GradientGenerator.propTypes = {
    color: PropTypes.string,
    onChange: PropTypes.func,
}